module.exports = __webpack_public_path__ + "static/media/jest.64ef8c35.png";